/**
 * Anteprima a schermo di un documento generato dal server.
 *
 * Controllare un consuntivo prima di mandarlo al cliente voleva dire
 * scaricarlo, cercarlo nei download, aprirlo e poi buttarlo: tre gesti per
 * ogni correzione, e nella cartella restavano dieci copie quasi uguali. Il PDF
 * lo converte già il server, quindi tanto vale guardarlo qui e scaricarlo solo
 * quando è quello giusto.
 */
import { useEffect, useState } from 'react';
import Modal from './Modal';

export default function AnteprimaDocumento({ titolo, carica, onChiudi, onScarica }) {
  const [url, setUrl] = useState(null);
  const [errore, setErrore] = useState(null);
  const [scaricando, setScaricando] = useState(false);

  // Il blob si chiede una volta sola, all'apertura, e si libera alla chiusura:
  // tenerlo appeso riempirebbe la memoria di PDF a ogni sbirciata.
  useEffect(() => {
    let vivo = true;
    let creato = null;
    carica()
      .then(blob => {
        if (!vivo) return;
        creato = URL.createObjectURL(blob);
        setUrl(creato);
      })
      .catch(e => { if (vivo) setErrore(e?.error || String(e)); });
    return () => { vivo = false; if (creato) URL.revokeObjectURL(creato); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal title={titolo || 'Anteprima del documento'} onClose={onChiudi} size="full">
      {errore && (
        <div className="bg-red-50 border border-red-200 text-red-800 rounded-lg p-3 text-sm">
          {errore}
          {/* La conversione in PDF dipende da LibreOffice sul server: se manca,
              il Word si scarica comunque e il messaggio lo dice. */}
        </div>
      )}
      {!errore && !url && (
        <div className="py-16 text-center text-gray-400 text-sm">Preparo il documento…</div>
      )}
      {url && (
        <>
          <iframe title={titolo || 'Anteprima'} src={url}
                  className="w-full h-[70vh] border rounded-lg bg-gray-50" />
          {/* Safari a volte non disegna un PDF dentro un riquadro: meglio una
              via d'uscita qui che un rettangolo bianco e nessuna spiegazione. */}
          <p className="text-xs text-gray-400 mt-2">
            Non si vede?{' '}
            <button className="text-brand-600 hover:underline"
                    onClick={() => window.open(url, '_blank')}>
              aprilo in una scheda
            </button>
          </p>
        </>
      )}
      {onScarica && (
        <div className="flex justify-end gap-2 mt-4">
          <button className="btn-secondary btn-sm" onClick={onChiudi}>Chiudi</button>
          <button className="btn-primary btn-sm" disabled={scaricando}
                  onClick={async () => {
                    setScaricando(true);
                    try { await onScarica(); } catch (e) { alert(e?.error || e); }
                    finally { setScaricando(false); }
                  }}>
            {scaricando ? 'Scarico…' : '⬇ Scarica'}
          </button>
        </div>
      )}
    </Modal>
  );
}
